'use strict';

angular.module('amexReconciliationApp')
  .service('TimeoutWarningModalService', function ($rootScope, SessionTimeoutService, $uibModal) {
    SessionTimeoutService.onTimeoutWarning($rootScope, openModal);

    function openModal() {
      var modal = $uibModal.open({
        template: '<session-timeout-warning-modal dismiss-modal-callback="$dismiss()"></session-timeout-warning-modal>'
      });

      // Logout behavior provided by the 'Log Out Now' button in the modal template.
      modal.result
        .catch(SessionTimeoutService.resetRemainingTime);
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/services/TimeoutWarningModalService.js
// module id = 648
// module chunks = 0